export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40ccef5eed60fb0de8082975f23056dd64919872b9&name=revalidateCommunity!'